module.exports = __webpack_public_path__ + "static/media/landing.a48ad620.jpeg";